import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  root: {
    backgroundColor: 'rgba(250, 250, 250, 0.40) !important',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 24,
    margin: 0,
    minHeight: '100vh',
    position: 'relative',
    padding: '0px 10px !important'
  },
  blobImage: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '40vw',
    height: 'auto',
    maxWidth: 600,

    opacity: 0.9
  },
  contentWrapper: {
    position: 'relative',
    zIndex: 2,
    width: '100%'
  },
  mainContent: {
    position: 'relative'
  },

  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 24,
    backdropFilter: 'blur(12.5px)',
    WebkitBackdropFilter: 'blur(12.5px)',
    borderRadius: 16,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    padding: 32
  },

  button: {
    position: 'fixed',
    right: '16px',
    zIndex: 3,
    display: 'flex',
    marginTop: '0px',
    backgroundColor: '#066E82',
    alignItems: 'center',
    width: '220px',
    height: '60px',
    fontWeight: 500,
    fontSize: 20
  },
  floatingButton: {
    position: 'sticky',
    bottom: '0px',
    right: '1px',
    zIndex: 3,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '130px',
    fontWeight: 500,
    padding: '8px 4px',
    fontSize: 20,
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)' /* Support Safari */,
    borderRadius: '12px',
    border: '1px solid rgba(255, 255, 255, 0.2)'
  }
});

export default useStyles;
